import gsap from 'gsap';
import JustValidate from 'just-validate';

class Order {
	constructor() {
		this.init();
	}

	init() {
		this.container = document.querySelector('[data-order]');

		if (!this.container) return;

		this._initValidation();
		this._initSections();
		setTimeout(() => {
			window.scrollTo(0, 0);
		}, 1000);
	}
	_initSections() {
		this.sections = Array.from(this.container.querySelectorAll('[data-order-section]')).map((section) => {
			return {
				isActive: section.classList.contains('_active'),
				name: section.getAttribute('data-order-section'),
				container: section,
				inputs: section.querySelector('.order-section__inputs'),
				openers: section.querySelectorAll('.order-section__card'),
				closer: section.querySelector('.order-section__next, .order-section__submit'),
			};
		});

		this.activeSection = this.sections.find((section) => section.isActive);

		this.sections.forEach((section) => {
			section.isActive ? this.openSection(section.name, true) : this.closeSection(section.name, true);
			const nextSectionName = section.closer?.getAttribute('data-order-next');

			section.inputs.querySelectorAll('input').forEach((input) => {
				input.addEventListener('change', () => {
					if (input.hasAttribute('data-ignore')) {
						return;
					}

					this._validateSection(section, section.closer);

					setTimeout(() => {
						this._validateSection(section, section.closer);
					}, 100);
				});
			});

			section.openers.forEach((opener) => {
				opener.addEventListener('click', () => {
					this.closeSection(this.activeSection?.name, false, false);
					this.openSection(section.name);
				});
			});
			section.closer?.addEventListener('click', () => {
				if (section.closer.type === 'submit') {
					return;
				}

				this.closeSection(section.name);
				this.openSection(nextSectionName);

				if (section.name === 'recipient') {
					section.container.setAttribute('data-order-recipient', 'filled');
				}
			});
		});
	}
	openSection(name, immediate = false) {
		if (!name) return;

		const section = this.sections.find((section) => section.name === name);

		if (!section) return;

		const duration = immediate ? 0 : 0.35;

		this.activeSection = section;
		this.activeSection.container.classList.add('_active');
		this.activeSection.isActive = true;

		this._validateSection();

		gsap.to(section.inputs, {
			autoAlpha: 1,
			duration: duration,
			ease: 'none',
		});

		gsap.to(this.activeSection.inputs, {
			height: 'auto',
			duration,
			onComplete: () => {
				gsap.set(section.inputs, {
					overflow: null,
				});
			},
		});
	}
	closeSection(name, immediate = false, scroll = true) {
		const section = this.sections.find((section) => section.name === name);

		if (!section) return;

		const duration = immediate ? 0 : 0.35;

		gsap.to(section.inputs, {
			autoAlpha: 0,
			duration,
			ease: 'none',
		});

		gsap.to(section.inputs, {
			height: 0,
			duration,
			onStart: () => {
				gsap.set(section.inputs, {
					overflow: 'hidden',
				});

				const isInViewPort = section.container.getBoundingClientRect().top > 0;

				if (scroll && !isInViewPort) {
					section.container.scrollIntoView({
						behavior: 'smooth',
						block: 'start',
					});
				}
			},
		});

		section.container.classList.remove('_active');
		section.isActive = false;
	}
	_initValidation() {
		const form = this.container.querySelector('form');
		const validator = new JustValidate(
			form,
			{
				lockForm: false,
			},
			[
				{
					key: 'required',
					dict: {
						ru: 'Обязательное поле',
					},
				},
				{
					key: 'email',
					dict: {
						ru: 'Неверный формат',
					},
				},
				{
					key: 'tel',
					dict: {
						ru: 'Неверный формат',
					},
				},
			],
		);
		validator.setCurrentLocale('ru');
		form.validator = validator;
		this.validator = validator;
		form.inited = true;
	}
	async _validateSection(section = this.activeSection, nextBtn = this.activeSection.closer) {
		if (!section || !nextBtn || section.name === 'delivery') return;
		let isValid = true;
		const inputs = Array.from(section.inputs.querySelectorAll('input')).filter((input) =>
			this.validator.fieldIds.has(`#${input.id}`),
		);
		for (const input of inputs) {
			if (!this.validator.fieldIds.has(`#${input.id}`)) {
				continue;
			}
			const valid = await this.validator.revalidateField(`#${input.id}`);
			if (!valid) {
				isValid = false;
			}
		}
		nextBtn.disabled = !isValid;
	}
}

export default new Order();
